import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { PROD, PIT_ROLES } from "../../../common/constants";
import { authKey, GET_GRN_LIST, GET_STAKEHOLDER_CATEGORY } from '../../../common/URLs';
import jwt from 'jwt-decode';
import './grnList.css';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { Container, CardContent, Box, Card, Typography, Stack, Grid, FormHelperText, Tooltip, IconButton, FormControl, InputLabel, Select, MenuItem, TextField, Button } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useTranslation } from "react-i18next";
import CustomDataGridToolbar from "../../../common/customDataGridToolbar";
import { Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { CloseIcon, SearchIcon, ViewIcon } from "../../../common/icons";
import BadgeComponent from "../../../common/badge";
import { mobileNoMaxLength, urnMaxLength } from "../../../common/commonValidations";
import apiClient from "../../../axios";
import CustomDataGridToolbarServer from "../../../common/customDataGridToolbarServer";
import dayjs from 'dayjs';

function GrnList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [tabValue, setTabValue] = React.useState(state?.tabValue ? state?.tabValue : 'RawBamboo');
  //const decoded = jwt(getLocalStorageItem('id_token'));
  const [asnDetails, setAsnDetails] = useState([]);
  const [selected, setSelected] = useState(asnDetails);
  const [searchFilter, setSearchFilter] = useState({
    "consignmentNo": "",
    "grnDate": null,
    "fromDate": null,
    "toDate": null,
    "stakeholderURN": "",
  });
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [stakeholderDetails, setStakeholderDetails] = useState();
  const [grnListData, setGrnListData] = useState();
  const [userRole, setUserRole] = useState();
  const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const [sortField, setSortField] = useState("CreatedOn");
  const [sortOrder, setSortOrder] = useState("desc");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [financialData, setFinancialData] = useState([]);
  const [selectedFY, setSelectedFY] = useState("");


  const onViewDetails = (cellValues) => {
    navigate('./GrnFormat', {
      state: { selectedRow: cellValues.row, pageName: "grnList", tabValue: tabValue }
    });
  }

  useEffect(() => {
    setUserRole(location?.state?.data);
    if (decoded.extension_URN) {
      getStakeDetails();
    }
  }, [decoded.extension_URN]);

  useEffect(() => {
    setGrnListData([]);
  }, [stakeholderDetails?.category ? stakeholderDetails?.category : ""]);

  function getStakeDetails() {
    loaderService.showLoader()
    apiClient
      .post(GET_STAKEHOLDER_CATEGORY,
        {
          "urn": decoded.extension_URN,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderDetails(response.data);
        getGrnList(response.data, tabValue, 0, pageSize, sortField, sortOrder, searchText);
        // getGrnList(response.data.category);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getGrnList = async (stakeHolderData, materialType, page, pageSize, sortField, sortOrder, searchInput) => {
    loaderService.showLoader();

    return await apiClient
      .post(
        GET_GRN_LIST,
        {
          stakeholderUrn: stakeHolderData?.urn
            ? stakeHolderData?.urn
            : getLocalStorageItem("role") === PIT_ROLES?.PlantSCMOperator
              ? "ABEPL"
              : searchFilter?.stakeholderURN ?? "",

          stakeholderType: stakeHolderData?.category
            ? stakeHolderData?.category
            : getLocalStorageItem("role") === PIT_ROLES?.PlantSCMOperator
              ? "Plant"
              : getLocalStorageItem("role") === PIT_ROLES?.LLESCMOperator
                ? "LLE"
                : "",

          consignmentNo: searchFilter?.consignmentNo ? searchFilter?.consignmentNo : null,
          grnDate: searchFilter?.grnDate ? searchFilter?.grnDate : null,

          materialType: materialType ? materialType : tabValue,
          fromDate: searchFilter?.fromDate ?? null,
          toDate: searchFilter?.toDate ?? null,

          pageNumber: page,
          pageSize: pageSize,
          filterText: searchInput ? searchInput : ""
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        const list = response?.data?.grnList || [];
        setGrnListData(list);
        setRowCount(response?.data?.rowCount || 0);

        if (response?.data?.totalGRNQuantityAmounts) {
          setFinancialData(response.data.totalGRNQuantityAmounts);
          if (!selectedFY && response.data.totalGRNQuantityAmounts.length > 0) {
            setSelectedFY(response.data.totalGRNQuantityAmounts[0].financialYear);
          }
        }

        loaderService.hideLoader();
        return list;
      })
      .catch((error) => {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error?.message || "Error fetching GRN list");
        return [];
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setSearchFilter((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  function searchGrnDetails(e) {
    e.preventDefault();
    setPage(0);
    getGrnList(stakeholderDetails, tabValue, 0, pageSize, sortField, sortOrder, searchText);
    // getGrnList("", "", page, pageSize, sortField, sortOrder, searchInput);
  }

  useEffect(() => {
    if (searchFilter?.fromDate === null & searchFilter?.toDate !== null) {
      toast.error("Please select GRN From Date and GRN To Date")
    }
    else getGrnList(stakeholderDetails, tabValue, 0, pageSize, sortField, sortOrder, searchText);
  }, [searchFilter])

  function clearSearch(e) {
    e.preventDefault();
    setPage(0);
    setSearchText("");
    setSearchFilter({
      consignmentNo: "",
      grnDate: null,
      fromDate: null,
      toDate: null,
      stakeholderURN: "",
    })
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setPage(0);
    setSearchText("");
    getGrnList(stakeholderDetails, newValue, 0, pageSize, sortField, sortOrder, searchText)
  };

  const columns = [
    { field: 'grnNo', headerName: 'GRN No', width: 150 },
    { field: 'consignmentNo', headerName: 'Consignment No', width: 150 },
    {
      field: 'poNo', headerName: 'PO Number', width: 150,
      valueGetter: (params) => params?.row?.grnPoDetailsList?.[0]?.poNo ?? '',
      renderCell: (params) => params?.value || ''
    },
    {
      field: 'grnDate', headerName: t('reg.date'), width: 120,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    {
      field: "challanNo", headerName: t('pit.challanNo'), width: 150
    },
    {
      field: 'stakeholderSourceUrn', headerName: 'Source URN', width: 150,
      valueGetter: (params) => params?.row?.grnPoDetailsList?.[0]?.stakeholderSourceUrn ?? '',
      renderCell: (params) => params?.value || ''
    },
    {
      field: 'stakeholderSourceName', headerName: 'Source Name', width: 180,
      renderCell: (params) => {
        return (
          <>{params?.row?.grnPoDetailsList?.[0]?.stakeholderSourceName}</>
        );
      },
      valueGetter: (params) => params?.row?.grnPoDetailsList?.[0]?.stakeholderSourceName ?? '',
      renderCell: (params) => params?.value || ''
    },
    { field: 'deliveryStakeholderUrn', headerName: 'Destination URN', width: 150 },
    {
      field: 'deliveryStakeholderName', headerName: 'Destination Name', width: 200,
      renderCell: (params) => {
        return (
          <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
            {params.value}
          </div>
        )
      },
      valueGetter: (params) => params.value
    },
    {
      field: 'shippedByName', headerName: 'Transporter Name', width: 250, hide: tabValue === "RawBamboo",
      renderCell: (params) => {
        return (
          <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
            {params.value}
          </div>
        )
      },
      valueGetter: (params) => params.value
    },
    { field: 'pickupTotalWeight', headerName: 'PickUp Quantity (MT)', width: 140 },
    { field: 'destinationTotalWeight', headerName: 'Unloading Quantity (MT)', width: 150 },
    { field: 'sapGrnNumber', headerName: 'SAP Grn Number', width: 150 },
    { field: 'totalInvoiceAmount', headerName: 'Total Invoice Amount', width: 180 },
    // {userDetails?.user?.userRoles?.[0].roleName === 'ABRPL SCM End User' ? 
    // // <>
    // { field: 'comments', headerName: 'Comments(Approver 1)', width: 300, hide: userRole === "Transportation Incharge" && true }

    // { field: 'deliveryStakeholderName', headerName: 'First Party Name', width: 140, hide: !(userRole === PIT_ROLES.PitScmUser) },
    // { field: 'deliveryStakeholderUrn', headerName: 'First Party URN', width: 150, hide: !(userRole === PIT_ROLES.PitScmUser) },

    // </>
    //                                  : null} 
    {
      field: 'actions', headerName: 'Action', width: 100,
      renderCell: (cellValues) => {
        return (
          <Tooltip title="View">
            <IconButton
              color="primary"
              onClick={() => onViewDetails(cellValues)}
            >
              <ViewIcon />
            </IconButton>
          </Tooltip>
        );
      }
    },
  ];

  const handleDateChange = (name, value) => {
    const formatted = value ? value.format("YYYY-MM-DD") : null;

    setSearchFilter((prev) => {
      if (
        name === "toDate" &&
        prev.fromDate &&
        dayjs(prev.fromDate).isAfter(value)
      ) {
        return {
          ...prev,
          toDate: formatted,
          fromDate: formatted
        };
      }

      return {
        ...prev,
        [name]: formatted
      };
    });
  };

  const fetchSearchData = async (searchInput) => {
    setSearchText(searchInput);
    setPage(0);
    await getGrnList(stakeholderDetails, tabValue, page, pageSize, sortField, sortOrder, searchInput);
  };
  const fetchData = async () => {
    return await getGrnList(stakeholderDetails, tabValue, 0, 0, sortField, sortOrder, searchText);
  }
  useEffect(() => {
    if (getLocalStorageItem('role')) {
      getGrnList("", tabValue, 0, pageSize, sortField, sortOrder, searchText);
    }
  }, [getLocalStorageItem('role')]);

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT18</p>}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h5">GRN List</Typography>

          {tabValue === 'RawBamboo' && financialData.length > 0 && (
            <Stack direction="row" spacing={2} alignItems="center" sx={{ bgcolor: '#f8f9fa', p: 1, borderRadius: 1, border: '1px solid #e0e0e0' }}>

              {financialData.filter(i => i.financialYear === selectedFY).map((data) => (
                <Stack direction="row" spacing={2} key={data.financialYear}>
                  <Box>
                    <Typography variant="caption" color="textSecondary" display="block">Total Quantity</Typography>
                    <Typography variant="body1" fontWeight="bold">{data.totalQuantity?.toLocaleString()} MT</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="textSecondary" display="block">Total Amountt</Typography>
                    <Typography variant="body1" fontWeight="bold">₹{data.totalAmount?.toLocaleString()}</Typography>
                  </Box>
                </Stack>
              ))}

              <FormControl size="small" sx={{ minWidth: 160 }}>
                <InputLabel sx={{ fontSize: '0.8rem' }}>FY</InputLabel>
                <Select
                  value={selectedFY}
                  label="FY"
                  onChange={(e) => setSelectedFY(e.target.value)}
                  sx={{ fontSize: '0.9rem', height: 35 }}
                >
                  {financialData.map((item) => (
                    <MenuItem key={item.financialYear} value={item.financialYear}>
                      {item.financialYear}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          )}
        </Stack>
        <Card>
          <CardContent>
            <Grid container spacing={2} >
              <Grid item xs={12} lg={3}>
                <FormControl fullWidth >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="GRN Date"
                      value={searchFilter?.grnDate || null}
                      inputFormat="DD/MM/YYYY"
                      onChange={(value) => handleDateChange("grnDate", value)}
                      renderInput={(params) => (
                        <TextField {...params} size="small" fullWidth />
                      )}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField fullWidth size="small"
                  label="Consignment No"
                  name="consignmentNo"
                  value={searchFilter?.consignmentNo || ''}
                  onChange={(e) => handleChange(e)}
                  sx={{ paddingRight: '3%' }}
                  inputProps={{
                    maxLength: "10"
                  }}
                  onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                />
                <BadgeComponent currentLength={searchFilter?.consignmentNo?.length} maxLength={mobileNoMaxLength} />
              </Grid>
              <Grid item xs={12} lg={3}>
                <FormControl fullWidth >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="GRN From Date"
                      value={searchFilter?.fromDate ? dayjs(searchFilter.fromDate) : null}
                      inputFormat="DD/MM/YYYY"
                      maxDate={
                        searchFilter?.toDate
                          ? dayjs(searchFilter.toDate)
                          : dayjs()
                      }
                      onChange={(value) => handleDateChange("fromDate", value)}
                      renderInput={(params) => (
                        <TextField {...params} size="small" fullWidth />
                      )}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={3}>
                <FormControl fullWidth >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="GRN To Date"
                      value={searchFilter?.toDate ? dayjs(searchFilter.toDate) : null}
                      inputFormat="DD/MM/YYYY"
                      maxDate={dayjs()}
                      onChange={(value) => handleDateChange("toDate", value)}
                      renderInput={(params) => (
                        <TextField {...params} size="small" fullWidth />
                      )}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField fullWidth size="small"
                  label="Stakeholder URN"
                  name="stakeholderURN"
                  value={searchFilter?.stakeholderURN || ''}
                  onChange={(e) => handleChange(e)}
                  sx={{ paddingRight: '3%' }}
                  inputProps={{
                    maxLength: "12"
                  }}
                  onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                />
                <BadgeComponent currentLength={searchFilter?.stakeholderURN?.length} maxLength={urnMaxLength} />
              </Grid>
              {/* <Grid item xs={12} lg={3}>
                <TextField fullWidth size="small"
                  label="Material Type"
                  name="materialtype"
                  value={searchFilter.materialtype}
                  onChange={(e) => handleChange(e)}
                  sx={{ paddingRight: '3%' }}
                  inputProps={{
                    maxLength: "15"
                  }}
                />
              </Grid> */}
              <Grid item xs={12} lg={3}>
                {/* <Button startIcon={<SearchIcon />} variant="contained" color="primary" onClick={(e) => searchGrnDetails(e)} >
                  Search
                </Button> */}
                <Button sx={{ ml: 1 }} startIcon={<CloseIcon />} variant="outlined" color="primary" onClick={(e) => clearSearch(e)} >
                  Clear Search
                </Button>
              </Grid>

            </Grid>
            <TabContext value={tabValue} mt={2}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabChange}>
                  <Tab label="Raw Bamboo" value="RawBamboo" />
                  {(getLocalStorageItem('role') === PIT_ROLES?.PitScmUser || getLocalStorageItem('role') === PIT_ROLES?.PlantSCMOperator || getLocalStorageItem('role') === PIT_ROLES?.Incharge) ? <Tab label="Chip Bamboo" value="ChipBamboo" /> : null}
                </TabList>
              </Box>
              <TabPanel value="RawBamboo">
                <Box style={{ height: 500, width: '100%' }}>
                  {
                    grnListData &&
                    <DataGrid rows={grnListData}
                      rowCount={rowCount}
                      rowsPerPageOptions={[10, 20, 50, 100]}
                      columns={columns}
                      page={page}
                      pageSize={pageSize}
                      paginationMode="server"
                      onPageChange={(newPage) => {
                        setPage(newPage);
                        getGrnList(stakeholderDetails, 'RawBamboo', newPage, pageSize, sortField, sortOrder, searchText);
                      }}
                      onPageSizeChange={(newPageSize) => {
                        setPageSize(newPageSize);
                        getGrnList(stakeholderDetails, 'RawBamboo', page, newPageSize, sortField, sortOrder, searchText);
                      }}
                      components={{ Toolbar: CustomDataGridToolbarServer }}
                      componentsProps={{ toolbar: { columns: columns, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "GRN_RB.xlsx", dateFields: ['grnDate'] } }}
                    />
                  }
                </Box>
              </TabPanel>
              <TabPanel value="ChipBamboo">
                <Box style={{ height: 500, width: '100%' }}>
                  {
                    grnListData &&
                    <DataGrid rows={grnListData}
                      columns={columns}
                      rowCount={rowCount}
                      rowsPerPageOptions={[10, 20, 50, 100]}
                      page={page}
                      pageSize={pageSize}
                      paginationMode="server"
                      onPageChange={(newPage) => {
                        setPage(newPage);
                        getGrnList(stakeholderDetails, 'ChipBamboo', newPage, pageSize, sortField, sortOrder, searchText);
                      }}
                      onPageSizeChange={(newPageSize) => {
                        setPageSize(newPageSize);
                        getGrnList(stakeholderDetails, 'ChipBamboo', page, newPageSize, sortField, sortOrder, searchText);
                      }}
                      components={{ Toolbar: CustomDataGridToolbarServer }}
                      componentsProps={{ toolbar: { columns: columns, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "GRN_CB.xlsx", dateFields: ['grnDate'] } }}
                    />
                  }
                </Box>
              </TabPanel>
            </TabContext>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}
export default GrnList;